import styled, {css} from 'styled-components';
import {Button} from '@guestapp/old-ui-kit';

export const Form = styled.form<{$isPasswordStep?: boolean}>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 16px;

  ${({$isPasswordStep}) =>
    $isPasswordStep &&
    css`
      margin-top: 32px;
    `}
`;

export const ContinueButton = styled(Button)<{$isPasswordStep?: boolean}>`
  text-transform: capitalize;
  ${({$isPasswordStep}) =>
    $isPasswordStep &&
    css`
      margin-top: 24px;
    `}
`;

export const StyledLinkButton = styled(Button)`
  height: 48px;
`;

export const ErrorMessage = styled.div`
  color: #ef4444;
  font-size: 14px;
  text-align: center;
  margin-bottom: -24px;
  margin-top: -9px;
`;
